'use client';

import Header from '@/components/common/Header';
import PrivacyPolicyInteractive from './components/PrivacyPolicyInteractive';
import FooterWrapper from '@/components/common/FooterWrapper';

export default function PrivacyPolicyPage() {
  return (
    <>
      <Header />
      <main>
        <PrivacyPolicyInteractive />
      </main>
      <FooterWrapper />
    </>
  );
}